// extracted by mini-css-extract-plugin
export default {"container":"_odc","arrow":"o5Wf","itemsWrapper":"jF_L","item":"sMBP"};